import React, { Fragment, PureComponent, Suspense } from 'react';
import {
    Button, Checkbox, Col, Divider, Input, message, Row,
    Skeleton, Table, Form, Card, Tabs,
} from 'antd'
import moment from 'moment'

// Now API
import {
    flight_searching_api_response,
    flight_static_searching_db_api_response
} from '../../helper/api_v1/flight_search'

import ExcelExport from './../../utils/xlsx'


export default class ComStaticSearch extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            btnLoading: false,
            db_btnLoading: false,
            setPinCode: "",
            flight_for_gozayaan: false,
            flight_for_sharetrip: false,
            flight_for_bdtickets: false,
            flight_for_flightexpert: false,
            vender: [
                { label: 'FlightExpert', value: 'flightexpert' },
                { label: 'Go Zayaan', value: 'gozayaan' },
                { label: 'Sharetrip', value: 'sharetrip' },
                { label: 'BD Tickets', value: 'bdtickets' },
            ],
            filters: [],
            venderSelected: [],
            sharetrip_trip_amnt: 0,
            gozayaan_trip_amnt: 0,
            bdtickets_trip_amnt: 0,
            flightexpert_trip_amnt: 0,

            adult: 1,
            origin: props.origin,
            destination: props.destination,
            end_time: props.end_time,
            classes: props.classes,
            dataSource: [],

            db_dataSource: [],

            setDefPinCode: '',// "Dhan_1V3#"

            is_review_the_searching: true
        }
    }


    // NOTE Searching Interval Added
    flight_searching_interval = async () => {

        await this.func_flight_search()
        setInterval(async () => {
            await this.func_flight_search()
            message.destroy()
            message.info("Price Updated")
        }, 100000)

    }


    // NOTE Flight Search
    func_flight_search = async () => {

        let {
            setPinCode,
            setDefPinCode,
            vender,
            origin,
            destination,
            end_time,
            flight_for_gozayaan,
            flight_for_sharetrip,
            flight_for_bdtickets,
            flight_for_flightexpert,
            // classes
        } = this.state

        origin = this.props.origin
        destination = this.props.destination
        end_time = this.props.end_time
        // classes = this.props.classes

        if (vender.length === 0) {

            message.error('Select Source')

        } else if (origin === "" || destination === "") {

            message.error("Please Check The Origin or Destination")

        } else {

            if (setPinCode === setDefPinCode) {

                let filterss = []
                let depDate = end_time

                let flight_searching = []
                let source = {}

                if (flight_for_sharetrip) {
                    source = { ...source, b: "Sharetrip" }
                    filterss.push({ text: 'Sharetrip', value: 'Sharetrip' })
                }
                if (flight_for_gozayaan) {
                    source = { ...source, d: "Go Zayaan" }
                    filterss.push({ text: 'Go Zayaan', value: 'Go Zayaan' })
                }
                if (flight_for_bdtickets) {
                    source = { ...source, c: "BDTickets" }
                    filterss.push({ text: 'BDTickets', value: 'BDTickets' })
                }

                if (flight_for_flightexpert) {
                    source = { ...source, a: "FlightExpert" }
                    filterss.push({ text: 'FlightExpert', value: 'FlightExpert' })
                }

                this.setState({ filters: filterss })
                let rets = {}

                if (filterss.length === 0) {
                    
                    message.destroy()
                    message.info("Source Not Selected")
                 
                } else {

                    if (this.state.dataSource.length === 0) {
                        this.setState({ dataSource: [], btnLoading: true })
                        message.destroy()
                        message.loading("Please Wait...", 0)
                    }

                    try {
                        rets = await flight_searching_api_response({ origin, destination, depDate, source })
                    } catch (error) {
                        console.log("API Error")
                        rets = {}
                    }

                    if (rets && Array.isArray(rets.search_result)) {
                        flight_searching.push(...rets.search_result)
                    } else {
                        message.destroy()
                        message.info("No Searching Selected")
                        this.setState({
                            btnLoading: false
                        })
                    }

                    if (flight_searching.length === 0) {

                        message.destroy()
                        message.info("No Searching Selected")
                        this.setState({
                            btnLoading: false
                        })

                    } else {

                        Promise.all(flight_searching).then(rest => {
                            
                            if (rest && rest.length !== 0) {

                                let abcReturn = [];

                                Array.isArray(rest) && rest.map(itt => {
                                    return abcReturn.push(itt)
                                })

                                if (this.state.dataSource.length === 0) {
                                    message.destroy()
                                    message.success("Completed")
                                }

                                this.setState({ dataSource: abcReturn, btnLoading: false })

                            } else {

                                message.destroy()
                                message.info("Please check the problem")
                                this.setState({ btnLoading: false })

                            }

                        }).catch(errorCat => {

                            message.destroy()
                            message.error("Error, Please wait...")
                            this.setState({ btnLoading: false })
                        
                        })
                    }
                }
            } else {
                message.destroy()
                message.error("Pin Not Matched")
            }
        }
    }

    // NOTE Flight Search From DB
    db_func_flight_search = async () => {

        message.destroy()
        message.loading("Please Wait...", 0)

        this.setState({
            db_btnLoading: true
        })

        let statis_search = await flight_static_searching_db_api_response({})

        message.destroy()
        message.destroy()

        this.setState({
            db_dataSource: statis_search.search_result,
            db_btnLoading: false,
            filters: [
                { text: 'Sharetrip', value: 'Sharetrip' },
                { text: 'Go Zayaan', value: 'Go Zayaan' },
                { text: 'BDTickets', value: 'BDTickets' },
                { text: 'FlightExpert', value: 'FlightExpert' }
            ]
        })
    }

    // NOTE Excel Export Print
    excelExportPrint = () => {
        const { dataSource } = this.state;
        let data = []
        dataSource.map(item => {
            return data.push({
                "Source": item.source,
                "Origin": item.origin,
                "destination": item.destination,
                "Flight Time": item.total_flight_time,
                "Departure Time": item.departure_time,
                "Base Price": item.base_fare,
                "Tax": item.tax,
                "Final Price": item.calctd_price,
                "~Discount Price": 0,
            })
        })
        ExcelExport(data, `Report ${moment().format('DD/MM/YYYYY')}`)
    }

    // NOTE From DB Excel Export Print
    db_excelExportPrint = () => {
        const { db_dataSource } = this.state;
        let data = []
        db_dataSource.map(item => {
            return data.push({
                "Source": item.source,
                "Origin": item.origin,
                "destination": item.destination,
                "Flight Time": item.total_flight_time,
                "Departure Time": item.departure_time,
                "Base Price": item.base_fare,
                "Tax": item.tax,
                "Final Price": item.calctd_price,
                "~Discount Price": 0,
            })
        })
        ExcelExport(data, `Report ${moment().format('DD/MM/YYYYY')}`)
    }

    searching = (_parameterSearching) => {
        this.setState(_parameterSearching)
    }

    render() {
        const {
            dataSource,
            db_dataSource,
            venderSelected,
            btnLoading,
            db_btnLoading,
            filters
        } = this.state

        return (
            <Fragment>
                <Fragment>
                    <Suspense fallback={<Skeleton />}>
                        <Tabs>

                            <Tabs.TabPane key={1} tab="Normal Search">
                                <Card
                                    key={13}
                                    bordered={false}
                                    title={"Check Source"}
                                >
                                    <Checkbox.Group
                                        style={{ width: "100%" }}
                                        // options={vender}
                                        onChange={(value) => {
                                            this.setState({
                                                flight_for_gozayaan: value.find(i => i === "gozayaan") ? true : false,
                                                venderSelected: value
                                            })
                                            this.setState({
                                                flight_for_sharetrip: value.find(i => i === "sharetrip") ? true : false,
                                                venderSelected: value
                                            })
                                            this.setState({
                                                flight_for_bdtickets: value.find(i => i === "bdtickets") ? true : false,
                                                venderSelected: value
                                            })
                                            this.setState({
                                                flight_for_flightexpert: value.find(i => i === "flightexpert") ? true : false,
                                                venderSelected: value
                                            })
                                        }}
                                    >
                                        <Row gutter={16}>
                                            <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                                                <Checkbox value="flightexpert">FlightExpert</Checkbox>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                                                <Checkbox value="gozayaan">Go Zayaan</Checkbox>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                                                <Checkbox value="sharetrip">Sharetrip</Checkbox>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={4} xl={4}>
                                                <Checkbox value="bdtickets">BD Tickets</Checkbox>
                                            </Col>
                                        </Row>
                                    </Checkbox.Group>

                                    {
                                        venderSelected && venderSelected.length === 10 &&
                                        <Fragment>
                                            <Row gutter={16} style={{ marginTop: 15 }}>
                                                {
                                                    venderSelected.find(is => is === "gozayaan") && (
                                                        <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                                            <Form layout="vertical">
                                                                <Form.Item label="Go Zayaan Discount Price:">
                                                                    <Input
                                                                        width="100%"
                                                                        placeholder="Go Zayaan"
                                                                        onChange={e =>
                                                                            this.setState({ gozayaan_trip_amnt: e.target.value })
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </Form>
                                                        </Col>
                                                    )
                                                }
                                                {
                                                    venderSelected.find(is => is === "sharetrip") && (
                                                        <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                                            <Form layout="vertical">
                                                                <Form.Item label="Sharetrip Discount Price:">
                                                                    <Input
                                                                        width="100%"
                                                                        placeholder="Sharetrip"
                                                                        onChange={e =>
                                                                            this.setState({ sharetrip_trip_amnt: e.target.value })
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </Form>
                                                        </Col>
                                                    )
                                                }
                                                {
                                                    venderSelected.find(is => is === "bdtickets") && (
                                                        <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                                            <Form layout="vertical">
                                                                <Form.Item label="BD Tickets Discount Price:">
                                                                    <Input
                                                                        width="100%"
                                                                        placeholder="BD Tickets"
                                                                        onChange={e =>
                                                                            this.setState({ bdtickets_trip_amnt: e.target.value })
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </Form>
                                                        </Col>
                                                    )
                                                }
                                                {
                                                    venderSelected.find(is => is === "flightexpert") && (
                                                        <Col xs={20} sm={16} md={12} lg={8} xl={4}>
                                                            <Form layout="vertical">
                                                                <Form.Item label="FlightExpert Discount Price:">
                                                                    <Input
                                                                        width="100%"
                                                                        placeholder="FlightExpert"
                                                                        onChange={e =>
                                                                            this.setState({ flightexpert_trip_amnt: e.target.value })
                                                                        }
                                                                    />
                                                                </Form.Item>
                                                            </Form>
                                                        </Col>
                                                    )
                                                }
                                            </Row>
                                        </Fragment>
                                    }
                                </Card>


                                <Card
                                    title={"Static Search"}
                                    key={1}
                                    bordered={false}
                                    extra={[
                                        <Button
                                            key="1"
                                            onClick={this.excelExportPrint}
                                            hidden={dataSource.length !== 0 ? false : true}
                                            type="primary"
                                        >
                                            Export
                                        </Button>,
                                        <Button
                                            hidden={
                                                this.props.origin === "" ? true :
                                                    this.props.destination === "" ? true : false
                                            }
                                            key="11"
                                            onClick={this.flight_searching_interval}
                                            type="primary"
                                            size="middle"
                                            loading={btnLoading}
                                            style={{ marginLeft: 10 }}
                                        >
                                            Search
                                        </Button>
                                    ]}
                                >
                                    {
                                        dataSource && dataSource.length !== 0 &&
                                        <Fragment>
                                            <Divider orientation="center">
                                                Search Details
                                        </Divider>

                                            <Table
                                                rowKey="rowId"
                                                style={{ width: 'auto', margin: 2 }}
                                                size="small"
                                                dataSource={dataSource}
                                                columns={[{
                                                    title: 'Source',
                                                    dataIndex: 'source',
                                                    key: 'source',
                                                    align: "center",
                                                    filters: filters,
                                                    onFilter: (value, record) => record.source.indexOf(value) === 0
                                                }, {
                                                    title: 'Origin',
                                                    dataIndex: 'origin',
                                                    key: 'origin',
                                                    align: "center",
                                                },
                                                {
                                                    title: 'Destination',
                                                    dataIndex: 'destination',
                                                    key: 'destination',
                                                    align: "center",

                                                },
                                                {
                                                    title: 'Flight Time',
                                                    dataIndex: 'total_flight_time',
                                                    key: 'total_flight_time',
                                                    align: "center",

                                                },
                                                {
                                                    title: 'Departure Time',
                                                    dataIndex: 'departure_time',
                                                    key: 'departure_time',
                                                    align: "center",

                                                },
                                                {
                                                    title: 'Base Price',
                                                    dataIndex: 'base_fare',
                                                    key: 'base_fare',
                                                    align: "center",
                                                    sorter: (a, b) => Number(a.base_fare) - Number(b.base_fare),
                                                },
                                                {
                                                    title: 'Taxes',
                                                    dataIndex: 'tax',
                                                    key: 'tax',
                                                    align: "center",
                                                    sorter: (a, b) => Number(a.tax) - Number(b.tax),
                                                },
                                                {
                                                    title: 'Price',
                                                    dataIndex: 'calctd_price',
                                                    key: 'calctd_price',
                                                    align: "center",
                                                    sorter: (a, b) => Number(a.total_price) - Number(b.total_price),
                                                },
                                                {
                                                    title: '~Discount Price',
                                                    dataIndex: 'discount',
                                                    key: 'discount',
                                                    align: "center",
                                                    sorter: (a, b) => Number(a.discount) - Number(b.discount),
                                                }]}
                                                total={dataSource.length}
                                                pagination={false}
                                                scroll={{ x: "max-content" }}
                                            />
                                        </Fragment>
                                    }
                                </Card>

                            </Tabs.TabPane>

                            <Tabs.TabPane key={2} tab="Database Search">

                                <Card
                                    title={"Static Database Search"}
                                    key={1}
                                    bordered={false}
                                    extra={[
                                        <Button
                                            key="1"
                                            onClick={this.db_excelExportPrint}
                                            hidden={db_dataSource.length !== 0 ? false : true}
                                            type="primary"
                                        >
                                            Export
                                        </Button>,
                                        <Button
                                            key="11"
                                            onClick={this.db_func_flight_search}
                                            type="primary"
                                            size="middle"
                                            loading={db_btnLoading}
                                            style={{ marginLeft: 10 }}
                                        >
                                            Search
                                        </Button>
                                    ]}
                                >
                                    {
                                        db_dataSource && db_dataSource.length !== 0 &&
                                        <Fragment>
                                            <Divider orientation="center">
                                                Store Result
                                            </Divider>

                                            <Table
                                                rowKey="rowId"
                                                style={{ width: 'auto', margin: 2 }}
                                                size="small"
                                                dataSource={db_dataSource}
                                                total={db_dataSource.length}
                                                pagination={{ pageSize: 50 }}
                                                scroll={{ x: "max-content" }}
                                                columns={[
                                                    {
                                                        title: 'Source',
                                                        dataIndex: 'source',
                                                        key: 'source',
                                                        align: "center",
                                                        filters: filters,
                                                        onFilter: (value, record) => record.source.indexOf(value) === 0
                                                    }, {
                                                        title: 'Origin',
                                                        dataIndex: 'origin',
                                                        key: 'origin',
                                                        align: "center",
                                                    },
                                                    {
                                                        title: 'Destination',
                                                        dataIndex: 'destination',
                                                        key: 'destination',
                                                        align: "center",

                                                    },
                                                    {
                                                        title: 'Flight Time',
                                                        dataIndex: 'total_flight_time',
                                                        key: 'total_flight_time',
                                                        align: "center",

                                                    },
                                                    {
                                                        title: 'Departure Time',
                                                        dataIndex: 'departure_time',
                                                        key: 'departure_time',
                                                        align: "center",

                                                    },
                                                    {
                                                        title: 'Base Price',
                                                        dataIndex: 'base_fare',
                                                        key: 'base_fare',
                                                        align: "center",
                                                        sorter: (a, b) => Number(a.base_fare) - Number(b.base_fare),
                                                    },
                                                    {
                                                        title: 'Taxes',
                                                        dataIndex: 'tax',
                                                        key: 'tax',
                                                        align: "center",
                                                        sorter: (a, b) => Number(a.tax) - Number(b.tax),
                                                    },
                                                    {
                                                        title: 'Price',
                                                        dataIndex: 'calctd_price',
                                                        key: 'calctd_price',
                                                        align: "center",
                                                        sorter: (a, b) => Number(a.total_price) - Number(b.total_price),
                                                    },
                                                    // {
                                                    //     title: '~Discount Price',
                                                    //     dataIndex: 'discount',
                                                    //     key: 'discount',
                                                    //     align: "center",
                                                    //     sorter: (a, b) => Number(a.discount) - Number(b.discount),
                                                    // }
                                                ]}
                                            />
                                        </Fragment>
                                    }
                                </Card>

                            </Tabs.TabPane>
                        </Tabs>
                    </Suspense>
                </Fragment>

            </Fragment>
        );
    }
}

